var _path, _circle, _circle2, _circle3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "chat_svg__cls-1",
    d: "M149.54 41.74a10.49 10.49 0 0110.64 10.34v73.35a10.49 10.49 0 01-10.64 10.34h-15.6v27.74l-25.09-27.74H42.58a10.5 10.5 0 01-10.64-10.34V52.08a10.5 10.5 0 0110.64-10.34h107m0-11.65h-107a22.16 22.16 0 00-22.29 22v73.35a22.16 22.16 0 0022.29 22h61.1l21.62 23.9a11.65 11.65 0 0020.29-7.81v-16.11h3.95a22.16 22.16 0 0022.29-22V52.08a22.16 22.16 0 00-22.29-22z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "chat_svg__cls-1",
    cx: 63.08,
    cy: 96.21,
    r: 8.27
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "chat_svg__cls-1",
    cx: 95.22,
    cy: 96.21,
    r: 8.27
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "chat_svg__cls-1",
    cx: 132.05,
    cy: 96.21,
    r: 8.27
  })));
}

export default SvgChat;